import setIsFullOptionsShown from '../mutators/setIsFullOptionsShown';
import collectedOptions from '../config/collectedOptions';
import updateCategory from '../orchestrators/updateCategory';
import { OptionCategory } from 'owa-options-core';
import { orchestrator, action } from 'satcheljs';
import getDefaultCategory from '../utils/getDefaultCategory';

const initializeFullOptionsAction = action(
    'initializeFullOptions',
    (category?: string, subcategory?: string, option?: string) => ({
        category,
        subcategory,
        option,
    })
);

export default initializeFullOptionsAction;

export let initializeFullOptionsInternal = orchestrator(
    initializeFullOptionsAction,
    async optionsPath => {
        let { category, subcategory, option } = optionsPath;
        setIsFullOptionsShown(true);
        const categories = collectedOptions();
        const categoryKey = category || getDefaultCategory();
        const subcategoryKey =
            subcategory || getFirstSubCategoryForCategory(categoryKey, categories);
        await updateCategory(categoryKey, subcategoryKey, option);
    }
);

function getFirstSubCategoryForCategory(categoryKey: string, categories: OptionCategory[]) {
    let selectedCategory = categories.filter(category => category.key === categoryKey)[0];

    return (
        selectedCategory &&
        selectedCategory.subcategories &&
        selectedCategory.subcategories[0] &&
        selectedCategory.subcategories[0].key
    );
}
